import { BrandContext } from "core/context/BrandContextProvider";
import type { Brand } from "core/entities";
import { useContext } from "react";

/**
 * Gets the brand resolved from the application's two-letter brand code.
 */
export function useBrand(): Brand {
  const brand = useContext(BrandContext);
  if (!brand) {
    throw new Error(`Brand not found in context`);
  }
  return brand;
}
